import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJetbrains = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4557 4.90771L3.43586 4.90918C1.53801 4.90918 0 6.44768 0 8.34553V18.0542C0 19.0571 0.43838 20.0104 1.19977 20.6634L33.3978 48.2621C34.0208 48.7957 34.8141 49.0892 35.6344 49.0892H45.6543C47.5521 49.0892 49.0906 47.5508 49.0906 45.6529V35.9428C49.0906 34.9399 48.6523 33.9865 47.8909 33.3336L15.6928 5.73538C15.0699 5.20127 14.2765 4.90771 13.4557 4.90771Z",
			fill: "#FF8100"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2506 4.90771H3.43635C1.5385 4.90771 0 6.44621 0 8.34405V19.3909C0 19.5534 0.0117821 19.7159 0.0343632 19.8769L4.48688 51.048C4.7289 52.7411 6.17854 53.9983 7.88886 53.9983H21.1129C23.0112 53.9983 24.5497 52.4593 24.5493 50.561L24.5453 34.9193C24.5453 34.5501 24.4859 34.1834 24.369 33.8334L15.5101 7.25719C15.0424 5.85418 13.7297 4.90771 12.2506 4.90771Z",
			fill: "url(#paint0_linear_117156_1851)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.5635 0.00012207H21.9029C20.5284 0.00012207 19.2859 0.819444 18.7444 2.08254L5.18703 33.7151C5.00392 34.1427 4.90918 34.6036 4.90918 35.069V50.5635C4.90918 52.4613 6.44768 53.9998 8.34553 53.9998H23.5043C24.1831 53.9998 24.8468 53.7986 25.4119 53.4215L52.4697 35.3626C53.425 34.7254 53.9983 33.6527 53.9983 32.5045L53.9998 3.43647C53.9998 1.53862 52.4613 0.00012207 50.5635 0.00012207Z",
			fill: "url(#paint1_linear_117156_1851)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.8748 10.1251H10.125V43.8749H43.8748V10.1251Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3438 24.794H16.8571V16.5496H14.3438V14.3438H21.8016V16.5496H19.2883V24.794H21.8016V26.9999H14.3438V24.794Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0667 24.722H24.8839C25.2513 24.722 25.5786 24.6437 25.8648 24.4871C26.151 24.3304 26.3724 24.109 26.529 23.8228C26.6856 23.5366 26.7639 23.2098 26.7639 22.842V14.3438H29.2318V23.0131C29.2318 23.7725 29.0568 24.4552 28.7073 25.0609C28.3578 25.6666 27.8758 26.1413 27.2609 26.4846C26.646 26.8283 25.9561 26.9999 25.1909 26.9999H23.0667V24.722Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3438 37.1249H27.8437V39.6561H14.3438V37.1249Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_117156_1851",
			x1: -.605288,
			y1: 6.42903,
			x2: 20.3726,
			y2: 51.6758,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .1,
				stopColor: "#FC801D"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .59,
				stopColor: "#FE2857"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_117156_1851",
			x1: 3.56262,
			y1: 50.6405,
			x2: 53.0946,
			y2: 1.10809,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .21,
				stopColor: "#FE2857"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .7,
				stopColor: "#007EFF"
			})]
		})] })
	]
});
const ForwardRef = forwardRef(SvgJetbrains);
export { ForwardRef as ReactComponent };
